import { render, staticRenderFns } from "./TaskSuspended.vue?vue&type=template&id=3bd95ad3&"
import script from "./TaskSuspended.vue?vue&type=script&lang=ts&"
export * from "./TaskSuspended.vue?vue&type=script&lang=ts&"
import style0 from "./TaskSuspended.vue?vue&type=style&index=0&id=3bd95ad3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports